/** @format */

export const mediaQuery = {
  desktop: `@media (min-device-width: 1025px) and (hover: hover),
  (min-device-width: 1025px) and (-ms-high-contrast: none),
  (min-device-width: 1025px) and (-ms-high-contrast: active),
  (width: 5001px) and (height: 5001px)`,

  desktop_big: `@media screen and (min-width: 1024px) and (min-height: 640px) and (hover: hover),
  screen and (min-width: 1024px) and (min-height: 640px) and (-ms-high-contrast: none),
  screen and (min-width: 1024px) and (min-height: 640px) and (-ms-high-contrast: active)`,
};



// WEBPACK FOOTER //
// ./src/partners/themes/mediaQuery.js